import React from 'react';
import cx from 'clsx';
import infoQuery from '../../query/infoQuery';
import { sendEvent } from '../../utils/ga';
import * as themeStyles from '../../assets/theme.module.scss';
import { LayoutContext } from '../layout-context';

const PhoneEmailMsg = ({ textCenter }) => {
    const {
        phone1, phone2, email, fax,
    } = infoQuery();
    const layoutClass = cx(themeStyles.col12, themeStyles.colLg3, { [themeStyles.textCenter]: textCenter });

    function logEvent() {
        sendEvent('Callout Block', 'click', 'online consult');
    }

    return (
        <LayoutContext.Consumer>
            {({ showOnlineConsultModal }) => (
                <div className={themeStyles.row}>
                    <div className={cx(layoutClass, themeStyles.borderRight, themeStyles.borderGray300)}>
                        <p className={cx(themeStyles.textUppercase, themeStyles.textGray700, themeStyles.mb1)}>
                            即時詢問
                        </p>
                        <div className={cx(themeStyles.mb5, themeStyles.mbMd0)}>
                            <button
                                type="button"
                                className={cx(themeStyles.btn, themeStyles.btnLink, themeStyles.h4)}
                                onClick={() => {
                                    logEvent();
                                    showOnlineConsultModal();
                                }}
                                style={{ padding: 0 }}
                            >
                                線上客服
                            </button>
                        </div>
                    </div>
                    <div className={cx(layoutClass, themeStyles.borderRight, themeStyles.borderGray300)}>
                        <p className={cx(themeStyles.textUppercase, themeStyles.textGray700, themeStyles.mb1)}>
                            聯絡電話
                        </p>
                        <div className={cx(themeStyles.mb5, themeStyles.mbMd0)}>
                            <a href={`tel:${phone1}`} className={cx(themeStyles.h4, themeStyles.dBlock)} onClick={() => sendEvent('Callout Block', 'click', 'phone1')}>
                                {phone1}
                            </a>
                            <a href={`tel:${phone2}`} className={cx(themeStyles.h4, themeStyles.dBlock)} onClick={() => sendEvent('Callout Block', 'click', 'phone2')}>
                                {phone2}
                            </a>
                        </div>
                    </div>
                    <div className={cx(layoutClass, themeStyles.borderRight, themeStyles.borderGray300)}>
                        <p className={cx(themeStyles.textUppercase, themeStyles.textGray700, themeStyles.mb1)}>
                            傳真
                        </p>
                        <div className={cx(themeStyles.mb5, themeStyles.mbMd0)}>
                            <span className={themeStyles.h4}>
                                {fax}
                            </span>
                        </div>
                    </div>
                    <div className={layoutClass}>
                        <p className={cx(themeStyles.textUppercase, themeStyles.textGray700, themeStyles.mb1)}>
                            Email
                        </p>
                        <a href={`mailto:${email}`} className={themeStyles.h4} onClick={() => sendEvent('Callout Block', 'click', 'email')}>
                            {email}
                        </a>
                    </div>
                </div>
            )}
        </LayoutContext.Consumer>

    );
};

export default PhoneEmailMsg;
